export default {
  SET_BALANCE: (state: IPlayerState, balance: number) => {
    state.balance = balance
  },
  SET_USERNAME: (state: IPlayerState, name: string) => {
    state.username = name
  },
  SET_VERIFYNAME: (state: IPlayerState, name: string) => {
    state.verifyName = name
  },
  CLEAR_PLAYER: (state: IPlayerState) => {
    state.balance = 0
    state.verifyName = ''
    state.username = ''
  },
  SET_CLASSIC: (state: IPlayerState, classic: boolean) => {
    state.isClassic = classic
  },
};
